export function logout(){
    localStorage.removeItem('timezone');
    localStorage.removeItem('curLogin');
    localStorage.removeItem('baseUrl');
    sessionStorage.removeItem('token');
    window.location.href = "/setting";
}